import script from "./VideoPathsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoPathsModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__